import React from 'react';
import './PrivacyPolicy.css'; // Import the CSS file

const PrivacyPolicy: React.FC = () => {
    return (
        <div className="privacy-policy-container">
            <h1>Privacy Policy</h1>
            <p>
                At AIplify, we are committed to protecting your privacy and ensuring that your personal data is handled in compliance with the General Data Protection Regulation (GDPR). This Privacy Policy explains how we collect, use, and protect your information.
            </p>

            <h2>1. Information We Collect</h2>
            <p>We only collect your email address when you provide it to us through our services.</p>

            <h2>2. How We Use Your Information</h2>
            <p>We use your email address for the following purposes:</p>
            <ul>
                <li>To communicate with you regarding updates, offers, or support.</li>
                <li>To provide information about our services.</li>
            </ul>

            <h2>3. Sharing Your Information</h2>
            <p>We do not sell, rent, or share your email address with third parties, except in the following cases:</p>
            <ul>
                <li>When required by law or to comply with legal obligations.</li>
                <li>To protect our legal rights or prevent fraud.</li>
            </ul>

            <h2>4. Your Rights</h2>
            <p>Under GDPR, you have the following rights:</p>
            <ul>
                <li>The right to access your email address.</li>
                <li>The right to request deletion of your email address.</li>
                <li>The right to object to the processing of your email address.</li>
            </ul>

            <h2>5. Data Retention</h2>
            <p>We retain your email address only for as long as necessary to fulfill the purposes outlined in this policy or as required by law.</p>

            <h2>6. Security</h2>
            <p>We implement appropriate technical and organizational measures to protect your email address from unauthorized access, loss, or misuse.</p>

            <h2>7. Contact Us</h2>
            <p>
                If you have any questions or concerns about this Privacy Policy or your email address, please contact us at:
            </p>
            <p>Email: contact@aiplify.com</p>

            <p>
                By using our services, you agree to the terms of this Privacy Policy. We may update this policy from time to time, and we encourage you to review it periodically.
            </p>
        </div>
    );
};

export default PrivacyPolicy;
